var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MapModal',{staticClass:"newModelPosition cutTool",attrs:{"modalNode":_vm.modalNode,"submitData":_vm.submitData,"close":_vm.close,"title":_vm.cutTitle,"id":"addTrafficSimulation"}},[_c('template',{slot:"foot"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }